import type { EditorialSourceFragment } from "~/__generated__/graphql"

export function SuggestionBrief({ source }: { source: EditorialSourceFragment }) {
  const suggestion = source.suggestion
  if (!suggestion)
    return (
      <p className="mt-2 text-sm leading-6 text-muted-foreground">
        This story came from {source.feedSource?.name ?? "a saved source"}. There is no verified
        match to your profile yet. Read the original and choose your own angle.
      </p>
    )
  return (
    <div className="mt-3 space-y-3 text-sm leading-6">
      {!suggestion.current && (
        <p className="rounded-md bg-muted p-3">
          Your profile has changed. Refresh suggestions to match against your latest experience.
        </p>
      )}
      <p>{suggestion.rationale}</p>
      <p className="text-xs text-muted-foreground">
        Suggested connection · experience profile version {suggestion.profileVersion} ·{" "}
        {suggestion.profileSection}
      </p>
      <blockquote className="border-l-2 border-primary pl-3">{suggestion.profileQuote}</blockquote>
      <details className="text-muted-foreground">
        <summary className="cursor-pointer">Source evidence</summary>
        <blockquote className="mt-2 border-l-2 pl-3">{suggestion.sourceQuote}</blockquote>
        <p className="mt-2 text-xs">
          A feed excerpt is a discovery signal. Confirm the original before making factual claims.
        </p>
      </details>
      <p className="font-medium">{suggestion.reactionPrompt}</p>
      {suggestion.breakingCandidate && suggestion.current && (
        <p className="rounded-md bg-accent p-3 text-xs">
          Worth reviewing soon: a fresh primary-source announcement with a strong profile match.
          Dashboard only; no breaking-news notification has been sent.
        </p>
      )}
    </div>
  )
}
